import React, { Component } from "react";
import VideoPlayer from "simple-react-video-thumbnail";
import VerticalTabs from "./dashboardTabsComponent";
import {
  Container,
  Grid,
  Typography,
  Button,
  Card,
  Paper,
  CardContent,
  FormControlLabel,
  Switch,
  FormGroup,
  List,
  ListItem,
  Tooltip,
} from "@material-ui/core";
import Header from "../../../../common/components/Header";
import Footer from "../../../../common/components/Footer";
import { inventoryDetailById } from "../actions/dashboardAction";
import searchinventry from "../actions/dashboardaapi";
import getActivepackage from "../actions/dashboardaapi";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import listingImg from "../../../../assests/images/Group-1863@2x.png";
import NewContentWrapper from "../../../../common/components/newContentWrapper";
import chrono from "../../../../assests/chrono24.png";
import ebay from "../../../../assests/ebay.png";
import pricelistImg from "../../../../assests/listprice.png";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { addChornoListing, addInventoryImage } from "../../dealer/actions/dealerAction";
import { toast } from "react-toastify";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FbIcon from "../../../../assests/images/fb.png";
import { Alert, AlertTitle } from "@material-ui/lab";
import AddIcon from "../../../../../src/assests/images/add.png";
import defaulutImg from "../../../../assests/images/Bitmap.png";
import NoImageAvailable from '../../../../assests/images/no-image-available.jpg'
import { AudioCard, VideoCard } from "material-ui-player";
import SlowMotionVideoIcon from "@material-ui/icons/SlowMotionVideo";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { SpinnerRoundFilled } from "spinners-react";
import EditIcon from "@material-ui/icons/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getComponentActionList,
  isActionAllowed,
  getComponentViewsList,
  formatDate,
  renderInventoryStatusLabel,
} from "../../../../common/components/Helper/Utils";
import imageNotAvailable from '../../../../assests/images/img-soon.png';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Stack from '@mui/material/Stack';




// const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
// const theme = useTheme();
var Loader = require("react-loader");
const FB = window.FB;

const InventoryStatusLookup = {
  2: "Incoming",
  6: "Needs Service / Polish",
  7: "At Service",
  11: "Intake Complete",
  13: "Need to Post",
  12: "Invoiced",
  1: "Inhand",
  3: "Out on Memo",
  4: "On Hold / Reserved",
  8: "Need to Ship",
  9: "Shipped waiting on payment",
  10: "Sold & Cashed Out",
  5: "Available to Order",
};

class DealerInventoryDetailComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      purchaseDate: "NewDate",
      purchaseDate1: "NewDate1",
      fullScreen: true,
      open: false,
      setOpen: false,
      inventoryDetailByIdDetails: [],
      productDetails: [],
      prodId: "",
      displayUrl: false,
      manageResult: false,
      ChronoUrl: "",
      inventory_id: "",
      listed_on: "chrono",
      sold_status: "",
      enbleAltert: false,
      displaysharingImg: false,
      inventryPricelist: [],
      loaded: false,
      soldbtn: false,
      ebayAmout: "",
      croono21Ammount: "",
      retailAmount: "",
      listing_addon: false,
      accessData: [],
      viewData: [],
      // uploadimages: ''
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onsocialsearch1 = this.onsocialsearch1.bind(this);
    this.onsocialsearch2 = this.onsocialsearch2.bind(this);
    this.onsocialsearch3 = this.onsocialsearch3.bind(this);
    this.onsocialsearch4 = this.onsocialsearch4.bind(this);
    this.onsocialsearch5 = this.onsocialsearch5.bind(this);
    this.onsocialsearch6 = this.onsocialsearch6.bind(this);
    this.onsocialsearch7 = this.onsocialsearch7.bind(this);
    this.onsocialsearch8 = this.onsocialsearch8.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.onsocialsearch = this.onsocialsearch.bind(this);
    this.addChoonoListing = this.addChoonoListing.bind(this);
    this.changeRangeName = this.changeRangeName.bind(this);
    this.onclickfacebookshare = this.onclickfacebookshare.bind(this);
    // this.getproductDetails = this.getproductDetails.bind(this)
    this.editinvnetrydeatils = this.editinvnetrydeatils.bind(this);
    this.boxcheckboxselection = this.boxcheckboxselection.bind(this);
    this.editIconClick = this.editIconClick.bind(this);
    this.backNavigation = this.backNavigation.bind(this);
    this.handleClickBreadCrumbs = this.handleClickBreadCrumbs.bind(this);
    this.handleMyInventoryClick = this.handleMyInventoryClick.bind(this);
  }

  componentDidMount() {
    const linkStyle = {
      fontSize: '14px',
      color: 'black',
      backgroundColor: 'white',
      textDecoration: 'none',
      transition: 'color 0.3s',
      cursor: 'pointer',
    };

    const hoverStyle = {
      color: '#007bff',
      textDecoration: 'underline',
    };
    // console.log(this.state.loaded);
    // console.log("data.......")
    // console.log(this.props);
    const accessDataObject = getComponentActionList("inventory_details");
    const viewDataObject = getComponentViewsList("inventory_details");
    this.setState({ accessData: accessDataObject, viewData: viewDataObject });
    let productId = this.props.match.params.productId;
    let id = this.props.match.params.id;
    this.setState({
      inventory_id: id,
    });

    this.setState({
      ChronoUrl:
        "(Your Chrone24 xml url is URL(https://api.watchops.com/inventories/" +
        this.props.match.params.userId +
        "/c24-importer.xml))",
    });
    // this.props.inventoryDetailById(id);
    // const datagg = this.props.inventoryDetailById(id);
    searchinventry.getinventryDetails(id).then((res) => {
      // console.log("inventry", res.data);
      if (res.data.success === 1) {
        if (res.data.data && res.data.data.technical_details && typeof res.data.data.technical_details === 'string') {
          const technical_details = JSON.parse(res.data.data.technical_details)
          res.data.data.technical_details = technical_details
        }
        this.setState({
          inventoryDetailByIdDetails: res.data.data,
          prodId: res.data.data.productid,
        });
        // this.getproductDetails(this.state.prodId)
        if (this.state.prodId) {
          this.getpriceLsting(this.state.prodId);
        } else {
          this.setState({
            loaded: true,
          });
        }
        this.boxcheckboxselection();
        // this.getActivePackages();
        searchinventry.getActivepackage().then((res) => {
          if (res.data.data && res.data.data.listing_addon) {
            this.setState({
              listing_addon: res.data.data.listing_addon,
            });
          }
        });
      } else {
        this.setState({
          inventoryDetailByIdDetails: res.data,
          manageResult: true,
          loaded: true,
        });
      }
      // If navigation included pending media or a global upload is running, attach/trigger uploads after page load
      const pending = this.props.location?.state?.pendingMedia;
      const inventoryId = id;
      const globalPending = window.__pendingInventoryUploads && window.__pendingInventoryUploads[inventoryId];

      // clear pendingMedia from location state to avoid repeated uploads
      try {
        const newState = { ...(this.props.location.state || {}) };
        delete newState.pendingMedia;
        this.props.history.replace(this.props.location.pathname, newState);
      } catch (e) {}

      if (globalPending) {
        // attach to existing global upload promise and refresh after it completes
        window.__pendingInventoryUploads[inventoryId]
          .then(() => {
            delete window.__pendingInventoryUploads[inventoryId];
            searchinventry.getinventryDetails(inventoryId).then((res) => {
              if (res.data && res.data.success === 1) {
                this.setState({ inventoryDetailByIdDetails: res.data.data });
              }
            });
          })
          .catch(() => {
            try { delete window.__pendingInventoryUploads[inventoryId]; } catch (e) {}
          });
      } else if (pending && (pending.imageFiles?.length || pending.videoFiles?.length)) {
        this.uploadPendingMedia(inventoryId, pending);
      }
    });
    // console.log(res,"data")
  }
  getpriceLsting(id) {
    // console.log(id, "id");
    searchinventry.getinventrypriceList(id).then((res) => {
      // console.log("inventrypricelist", res.data.data);
      this.setState({
        inventryPricelist: res.data.data,
        loaded: true,
      });
      for (let i = 0; i < this.state.inventryPricelist.length; i++) {
        if (this.state.inventryPricelist[i].watch_source == "Chrono24") {
          this.setState({
            croono21Ammount: this.state.inventryPricelist[i].avg,
          });
        } else if (this.state.inventryPricelist[i].watch_source == "Retail") {
          this.setState({ retailAmount: this.state.inventryPricelist[i].avg });
        } else if (this.state.inventryPricelist[i].watch_source == "EBay") {
          this.setState({ ebayAmout: this.state.inventryPricelist[i].avg });
        }
      }
    });
  }

  uploadPendingMedia = (inventoryId, pending) => {
    if (!inventoryId || !pending) return;
    const imageFiles = pending.imageFiles || [];
    const videoFiles = pending.videoFiles || [];
    const uploads = [];
    const userDetails = sessionStorage.getItem("userDetails")
      ? JSON.parse(sessionStorage.getItem("userDetails"))
      : null;
    const modifiedBy = userDetails?.userId || userDetails?.id || null;

    imageFiles.forEach((f, index) => {
      if (!f || !f.file) return;
      const position = `preimage${index + 1}`;
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", position);
      fd.set("image", f.file);
      if (modifiedBy) fd.set("modified_by", modifiedBy);
      uploads.push(
        new Promise((resolve) => {
          addInventoryImage(fd, (error) => {
            if (error) {
              toast(error?.response?.data?.message || error?.message || "Image upload failed", {
                autoClose: 2000,
                type: toast.TYPE.ERROR,
                position: toast.POSITION.BOTTOM_CENTER,
              });
              return resolve({ success: false, error });
            }
            return resolve({ success: true });
          });
        }),
      );
    });

    videoFiles.forEach((v, index) => {
      if (!v || !v.file) return;
      const position = `video${index + 1}`;
      const fd = new FormData();
      fd.set("inventory_id", inventoryId);
      fd.set("position", position);
      fd.set("image", v.file);
      if (modifiedBy) fd.set("modified_by", modifiedBy);
      uploads.push(
        new Promise((resolve) => {
          addInventoryImage(fd, (error) => {
            if (error) {
              toast(error?.response?.data?.message || error?.message || "Video upload failed", {
                autoClose: 2000,
                type: toast.TYPE.ERROR,
                position: toast.POSITION.BOTTOM_CENTER,
              });
              return resolve({ success: false, error });
            }
            return resolve({ success: true });
          });
        }),
      );
    });

    if (uploads.length === 0) return;
    Promise.all(uploads).then(() => {
      // refresh inventory details after uploads
      searchinventry.getinventryDetails(inventoryId).then((res) => {
        if (res.data && res.data.success === 1) {
          this.setState({ inventoryDetailByIdDetails: res.data.data });
        }
      });
    });
  };

  getActivePackages() {
    // console.log("iam comng ");
  }

  handleClickBreadCrumbs(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
  }

  handleMyInventoryClick() {
    const { history } = this.props;
    history.push('/myinventory');
  };

  boxcheckboxselection() {
    if (this.state.inventoryDetailByIdDetails.sold == 1) {
      this.setState({
        soldbtn: true,
      });
      // console.log(this.state.soldbtn, "true");

    } else {
      this.setState({
        soldbtn: false,
      });
      // console.log(this.state.soldbtn, "false");
    }
    // console.log(this.state.soldbtn, "normal");
  }

  onclickfacebookshare() {
    this.setState({
      displaysharingImg: true,
    });
  }
  onsocialsearch1(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch2(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch3(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch4(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch5(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch6(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch7(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch8(e) {
    this.setState({
      uploadimages: e,
      displaysharingImg: false,
    });
    this.onsocialsearch(e);
  }
  onsocialsearch(uploadImages) {
    // console.log(uploadImages, "searchimage");
    this.setState({
      uploadimages: uploadImages,
    });
    window.fbAsyncInit = function () {
      window.FB.getLoginStatus(({ authResponse }) => { });
    };
    // console.log(uploadImages, "searchimage");
    FB.ui(
      {
        display: "popup",
        method: "feed",
        picture: uploadImages,
        link: uploadImages,
      },
      function (response) { }
    );
  }
  backNavigation() {
    const { history } = this.props;
    history.push("/myinventory");
    setTimeout(() => window.scrollTo(0, 0), 50);
  }

  addChoonoListing() {
    this.setState({ loaded: false });
    // console.log(this.props,"props",this.props.currentUser)
    let data = {
      inventory_id: this.state.inventory_id,
      listed_on: "chrono",
    };
    addChornoListing(data, (error, res) => {
      // console.log("res", res.data);
      if (res.data.success === 1) {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        Swal.fire(
          this.state.ChronoUrl,
          " <br>Use this Xml link for further Usage"
        );
        this.setState({
          displayUrl: true,
          loaded: true,
        });
      } else {
        this.setState({
          displayUrl: true,
          loaded: true,
        });
        Swal.fire(
          this.state.ChronoUrl,
          " <br>Use this Xml link for further Usage"
        );
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    });
  }
  // getproductDetails (id){
  //     searchinventry.getProductsDetails(id).then((res) => {
  //         console.log('product', res.data.data,);
  //         this.setState({
  //             productDetails: res.data.data
  //         })
  //     })
  // }
  // socialshare(e){
  //     console.log(e)
  // }
  editinvnetrydeatils() {
    this.props.history.push(
      "/update-inventry-details/" +
      this.state.inventoryDetailByIdDetails.inventoryid,
      this.props.history.location.state
    );
  }

  changeRangeName = (event) => {
    // console.log(event);
    const checkstaus = event.target.checked;
    // console.log(event.target.checked);
    if (checkstaus === true) {
      this.setState({
        inventory_id: this.state.inventoryDetailByIdDetails.inventoryid,
        sold_status: "1",
        soldbtn: true,
      });
      localStorage.setItem("sold_status", "1");
    } else {
      this.setState({
        inventory_id: this.state.inventoryDetailByIdDetails.inventoryid,
        sold_status: "0",
        soldbtn: false,
      });
      localStorage.setItem("sold_status", "0");
    }
    let data = {
      inventory_id: this.state.inventory_id,
      sold_status: localStorage.getItem("sold_status"),
      listed_on: this.state.listed_on,
    };
    // console.log(data, "detais");
    searchinventry.productsold(data).then((res) => {
      // console.log("res", res);
      if (res.data.success === 1) {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        localStorage.removeItem("sold_status");

        this.setState({
          enbleAltert: true,
        });
        // console.log(this.state.enbleAltert);
      } else {
        toast(res.data.message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
        localStorage.removeItem("sold_status");
        this.setState({
          enbleAltert: true,
        });
        // console.log(this.state.enbleAltert);
      }
    });
  };

  handleClickOpen() {
    this.setState({
      open: true,
      setOpen: true,
    });
  }

  handleClose() {
    this.setState({
      open: false,
      setOpen: false,
    });
  }
  editIconClick() {
    this.props.history.push(
      "/update-inventry-images-details/" +
      this.state.inventoryDetailByIdDetails.inventoryid
    );
  }
  newContentView() {
    // console.log(this.state.inventoryDetailByIdDetails, "logout");
    let inventoryDetailByIdInfo = "";
    let id = "";
    let inventoryDetailByIdDetails = "";
    // if(this.props.inventoryDetailByIdInfo.success == 0){
    //     inventoryDetailByIdInfo = this.props.inventoryDetailByIdInfo;
    // }else{
    //     inventoryDetailByIdInfo = this.props.inventoryDetailByIdInfo.data;
    //      id = inventoryDetailByIdInfo.id;
    //      inventoryDetailByIdDetails = (inventoryDetailByIdInfo && inventoryDetailByIdInfo.prodattr) ? inventoryDetailByIdInfo.prodattr : "";
    // }
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    if (this.state.manageResult) {
      return (
        <div
          style={{
            marginLeft: "400px",
            marginTop: "50px",
            textAlign: "center",
          }}
        >
          <Card style={{ width: "600px", textAlign: "center" }}>
            <CardContent>
              <Typography color="textSecondary" gutterBottom>
                <div> {this.state.inventoryDetailByIdDetails.message}</div>
              </Typography>
            </CardContent>
          </Card>
        </div>
      );
    } else {
      return (
        <div>
          <link rel="icon" href="./faviconw.png" />

          {this.state.loaded == false ? (
            <div class="d-spinner">
              <SpinnerRoundFilled
                size={51}
                thickness={125}
                speed={80}
                color="rgba(57, 107, 172, 1)"
                className="spp"
                enabled={this.state.loaded == false}
              />
            </div>
          ) : (
            <div>
              <div>
                <Container style={{ marginBottom: "10px" }}>
                  <Grid style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {/* <Grid>
                      <ArrowBackIcon
                        style={{
                          color: "action",
                          paddingRight: "15px",
                          marginTop: '5px',
                          fontSize: 40,
                          cursor: "pointer",
                        }}
                        onClick={this.backNavigation}
                      >

                      </ArrowBackIcon>
                    </Grid> */}
                    <Grid style={{ marginTop: '10px' }}>
                      {/* <Typography  variant="h5"
                        className="font-size-18"><b>Go Back</b></Typography> */}

                      <div onClick={this.handleClickBreadCrumbs}>
                        <Stack spacing={1}>
                          <Breadcrumbs aria-label="breadcrumb" separator={<span className="sperator">›</span>} >
                            <Link
                              className="link"
                              style={{ fontSize: '14px', color: '#CEA05F', textDecoration: 'underline !important', backgroundColor: 'white' }}
                              to={{
                                pathname: '/dealer-inventory',
                                state: { ...this.props.history.location.state }
                              }}
                            >
                              My Dealer Inventory
                            </Link>

                            <Link
                              style={{ fontSize: '14px', color: '#9e9e9e', backgroundColor: 'white' }}
                              aria-current="page"
                            >
                              Inventory Details
                            </Link>

                          </Breadcrumbs>
                        </Stack>
                      </div>
                    </Grid>
                  </Grid>
                  <Card style={{ marginTop: "20px" }}>
                    <Grid container sacing={2} style={{ padding: "1rem" }}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={5}
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0 1rem",
                        }}
                      >

                        {this.state.inventoryDetailByIdDetails &&
                          this.state.inventoryDetailByIdDetails.imagepaths ? (
                          <>
                            {isActionAllowed(
                              this.state.accessData,
                              "upload_inventory_images"
                            ) && (
                                <div onClick={this.editIconClick}>
                                  <EditIcon
                                    style={{
                                      backgroundColor: "#ccc",
                                      position: "relative",
                                      float: "right",
                                      bottom: "-5px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              )}
                          </>
                        ) : (
                          <>

                            <img src={NoImageAvailable} alt="NoImageAvailable" style={{ height: "250px", width: "250px" }} />
                            {/* {isActionAllowed(
                              this.state.accessData,
                              "upload_inventory_images"
                            ) && (
                                <>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    className="primary-bg color-white text-center form-width-30 float-right"
                                    onClick={this.editIconClick}
                                  >
                                    upload Images
                                  </Button>
                                </>
                              )} */}
                          </>
                        )}
                        <div
                          className="space-1"
                          style={{ textAlign: "center" }}
                        >
                          <Slider {...settings} className="slide-invdetail">
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .front ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.front
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.front
                                      : defaulutImg
                                  }
                                  alt="rolex"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "-5px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                             {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .back ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.back
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.back
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .left ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.left
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.left
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .right ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.right
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.right
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .wrist_shot ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.wrist_shot
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.wrist_shot
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                           
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .buckle_closed ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.buckle_closed
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.buckle_closed
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .buckle_opened ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.buckle_opened
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.buckle_opened
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            {this.state.inventoryDetailByIdDetails &&
                              this.state.inventoryDetailByIdDetails.imagepaths &&
                              this.state.inventoryDetailByIdDetails.imagepaths
                                .free_form ? (
                              <div
                                className="space-3"
                                style={{ textAlign: "center" }}
                              >
                                <img
                                  src={
                                    this.state.inventoryDetailByIdDetails &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths &&
                                      this.state.inventoryDetailByIdDetails
                                        .imagepaths.free_form
                                      ? this.state.inventoryDetailByIdDetails
                                        .imagepaths.free_form
                                      : defaulutImg
                                  }
                                  alt="client-logo-1"
                                  className="img-width-23 img-responsive1"
                                  style={{
                                    display: "initial",
                                    width: "auto",
                                    marginLeft: "0px",
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}

                          </Slider>
                          {/* <div className="text-center1 space-top-20">
                                                        <Link href="/" style={{ color: '#292C2F' }}></Link>
                                                    </div> */}
                          <div>
                            <div>
                              {
                                this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails.imagepaths
                                    .video ? (
                                  <div>
                                    {
                                      this.state.inventoryDetailByIdDetails &&
                                        this.state.inventoryDetailByIdDetails
                                          .imagepaths &&
                                        this.state.inventoryDetailByIdDetails
                                          .imagepaths.video ? (
                                        <VideoPlayer
                                          videoUrl={
                                            this.state
                                              .inventoryDetailByIdDetails &&
                                            this.state
                                              .inventoryDetailByIdDetails
                                              .imagepaths &&
                                            this.state
                                              .inventoryDetailByIdDetails
                                              .imagepaths.video + "?autoplay=1"
                                          }
                                          snapshotAt={10}
                                        />
                                      ) : (
                                        ""
                                      )
                                      // <Typography variant="h6" className="color-232323"><b>No video Found {this.state.UploadPic9}</b></Typography>
                                    }
                                  </div>
                                ) : (
                                  // <div className="space-3">
                                  //     <Grid container spacing={2}>
                                  //         <Grid>
                                  //             <h2>Inventory Video</h2>
                                  //         </Grid>
                                  //         <Grid>
                                  //             <Button style={{ marginTop: '15px' }}>
                                  //                 <SlowMotionVideoIcon onClick={this.handleClickOpen} />
                                  //             </Button>
                                  //         </Grid>
                                  //     </Grid>
                                  // </div>
                                  ""
                                )
                                // <Typography variant="h6" className="color-232323"><b>No Video Found {this.state.UploadPic9}</b></Typography>
                              }
                              {/* <h3>Inventory Video</h3>
                                            <Button>
                                            <SlowMotionVideoIcon  onClick={this.handleClickOpen}/>
                                            </Button> */}
                            </div>
                            <Dialog
                              // fullScreen={this.state.fullScreen}
                              open={this.state.open}
                              onClose={this.handleClose}
                              aria-labelledby="responsive-dialog-title"
                            >
                              {/* <DialogTitle id="responsive-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
                              <DialogContent style={{ paddingLeft: "0px" }}>
                                <DialogContentText>
                                  <div style={{ marginLeft: "10px" }}>
                                    <Typography variant="h6">
                                      <b>Watch Video {this.state.UploadPic9}</b>
                                    </Typography>
                                    <Grid container spacing={1}>
                                      <Grid item xs={6} sm={6} md={12} lg={12}>
                                        <div style={{ width: "580px" }}>
                                          {
                                            this.state
                                              .inventoryDetailByIdDetails &&
                                              this.state
                                                .inventoryDetailByIdDetails
                                                .imagepaths &&
                                              this.state
                                                .inventoryDetailByIdDetails
                                                .imagepaths.video ? (
                                              <VideoPlayer
                                                videoUrl={
                                                  this.state
                                                    .inventoryDetailByIdDetails &&
                                                  this.state
                                                    .inventoryDetailByIdDetails
                                                    .imagepaths &&
                                                  this.state
                                                    .inventoryDetailByIdDetails
                                                    .imagepaths.video +
                                                  "?autoplay=1"
                                                }
                                                snapshotAt={10}
                                              />
                                            ) : (
                                              ""
                                            )
                                            // <Typography variant="h6" className="color-232323"><b>No video Found {this.state.UploadPic9}</b></Typography>
                                          }
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </DialogContentText>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  autoFocus
                                  onClick={this.handleClose}
                                  color="primary"
                                >
                                  Close
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={7}>
                        {/* <div className="space-3">
                                                </div> */}
                        <div>
                          <Grid container>
                            <Grid item xs={12} sm={9} md={9}>
                              <div style={{ padding: "0px" }}>
                                {/* <Button variant="contained" color="primary" className=" float-right primary-bg color-white text-center1" style={{padding:"5px 15px", fontSize:"0.8rem"}} onClick={()=>{this.props.history.push({pathname: "/create/invoice",state: { inventoryDetails: {model: this.state?.inventoryDetailByIdDetails?.invattr?.reference, serialno: this.state?.inventoryDetailByIdDetails?.serialno, desc: this.state?.inventoryDetailByIdDetails?.description} }})}}>CREATE INVOICE</Button> */}
                                <Typography
                                  variant="h5"
                                  className="color-292C2F"
                                  style={{ fontSize: "1.2rem" }}
                                >
                                  <b>Inventory product details</b>
                                </Typography>
                              </div>
                              <div style={{ padding: "10px 0 10px" }}>
                                {/* <Button variant="contained" color="primary" className=" float-right primary-bg color-white text-center1" style={{padding:"5px 15px", fontSize:"0.8rem", top: '13px'}} onClick={this.editinvnetrydeatils}>EDIT</Button> */}
                                <Typography
                                  variant="h5"
                                  style={{ fontSize: "1rem" }}
                                >
                                  {this.state.inventoryDetailByIdDetails &&
                                    this.state.inventoryDetailByIdDetails
                                      .invattr &&
                                    this.state.inventoryDetailByIdDetails.invattr
                                      .productname &&
                                    this.state.inventoryDetailByIdDetails.invattr
                                      .productname
                                    ? this.state.inventoryDetailByIdDetails
                                      .invattr.productname
                                    : ""}{" "}
                                  {this.state.inventoryDetailByIdDetails &&
                                    this.state.inventoryDetailByIdDetails
                                      .invattr &&
                                    this.state.inventoryDetailByIdDetails.invattr
                                      .model &&
                                    this.state.inventoryDetailByIdDetails.invattr
                                      .model
                                    ? this.state.inventoryDetailByIdDetails
                                      .invattr.model
                                    : ""}
                                </Typography>
                              </div>
                              <div className="MuiGrid-spacing-xs-4">
                                <Grid container spacing={4}>
                                  <React.Fragment>
                                    {/* <Grid item xs={12} sm={12} md={4} style={{padding:"0px"}}>
                                                                            <img src={ebay} alt="" width="103px" style={{ padding: "5px 0px" }} />
                                                                            {this.state.ebayAmout ?
                                                                                <div style={{ marginLeft: '25px' }} className="eby">
                                                                                    <Typography variant="small">
                                                                                        ${(this.state.ebayAmout && this.state.ebayAmout.slice(0, 8))
                                                                                            ?
                                                                                            (this.state.ebayAmout && this.state.ebayAmout.slice(0, 8))
                                                                                            :
                                                                                            " ---"}
                                                                                    </Typography>
                                                                                </div>
                                                                                :
                                                                                <div style={{ marginLeft: '20px' }}>
                                                                                    <Typography variant="small">
                                                                                        {"---"}
                                                                                    </Typography>
                                                                                </div>

                                                                            }

                                                                        </Grid>
                                                                        <Grid item xs={12} sm={12} md={4} style={{padding:"0px 16px 0px"}}>
                                                                            <img src={chrono} alt="" width="103px" style={{ padding: "5px 0px" }} onClick={this.addChoonoListing} />
                                                                            <div>
                                                                                {this.state.croono21Ammount ? <Typography variant="small">${(this.state.croono21Ammount && this.state.croono21Ammount.slice(0, 8)) ? (this.state.croono21Ammount && this.state.croono21Ammount.slice(0, 8)) : " ---"}</Typography> : <Typography variant="small"> {"---"}</Typography>}
                                                                            </div>
                                                                        </Grid> */}
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={4}
                                      style={{ padding: "0px 16px 0px" }}
                                    >
                                      <img
                                        src={listingImg}
                                        alt=""
                                        width="103px"
                                        style={{ padding: "5px 0px" }}
                                      />
                                      <div>
                                        {this.state.retailAmount ? (
                                          <Typography variant="small">
                                            $
                                            {this.state.retailAmount &&
                                              this.state.retailAmount.slice(0, 8)
                                              ? this.state.retailAmount &&
                                              this.state.retailAmount.slice(
                                                0,
                                                8
                                              )
                                              : " List Price Not Available"}
                                          </Typography>
                                        ) : (
                                          <Typography variant="small">
                                            {" "}
                                            List Price Not Available
                                          </Typography>
                                        )}
                                      </div>
                                    </Grid>
                                  </React.Fragment>
                                </Grid>
                              </div>
                            </Grid>

                          </Grid>


                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </Container>

                {this.state.displaysharingImg ? (
                  <Container style={{ marginBottom: "10px" }}>
                    <div className="space-top-30">
                      <Typography
                        variant="h4"
                        className="font-size-24 color-232323 center-text"
                      >
                        <b>Select Images To Share</b>
                      </Typography>
                    </div>

                    <Grid container spacing={4}>
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .front ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Front
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.front
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch4(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.front
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.back ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Back
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.back
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch1(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.back
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .right ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Right
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.right
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch6(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.right
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.left ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                left
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.left
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch5(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.left
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}

                      {this.state.inventoryDetailByIdDetails.imagepaths.top ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Top
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.top
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch2(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.top
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .bottom ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Bottom
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.bottom
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch3(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.bottom
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .buckle_opened ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Buckle Opened
                              </Typography>

                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.buckle_opened
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch7(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.buckle_opened
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {this.state.inventoryDetailByIdDetails.imagepaths
                        .buckle_closed ? (
                        <Grid item xs={6} sm={3} md={3}>
                          <div>
                            <div className="boxshodow">
                              <Typography variant="h5" className="boxtitle">
                                Buckle Closed
                              </Typography>
                              <img
                                src={
                                  this.state.inventoryDetailByIdDetails &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths &&
                                  this.state.inventoryDetailByIdDetails
                                    .imagepaths.buckle_closed
                                }
                                alt="client-logo-1"
                                className="img-width-23 img-responsive2"
                                onClick={() => {
                                  this.onsocialsearch8(
                                    this.state.inventoryDetailByIdDetails
                                      .imagepaths.buckle_closed
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </Container>
                ) : (
                  <Container style={{ marginBottom: "10px" }}>
                    <Card
                      style={{
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        paddingTop: "10px",
                        paddingBottom: "20px",
                      }}
                    >
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={4}>
                          <div style={{ textAlign: "center" }}>
                            <Typography
                              variant="h5"
                              className="color-292C2F"
                              style={{ fontSize: "1rem" }}
                            >
                              <b>Product Specifications</b>
                            </Typography>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    List Price
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.retailAmount ? (
                                        <Typography variant="small">
                                          $
                                          {this.state.retailAmount &&
                                            this.state.retailAmount.slice(0, 8)
                                            ? this.state.retailAmount &&
                                            this.state.retailAmount.slice(
                                              0,
                                              8
                                            )
                                            : " List Price Not Available"}
                                        </Typography>
                                      ) : (
                                        <Typography variant="small">
                                          {" "}
                                          List Price Not Available
                                        </Typography>
                                      )}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {/* <hr style={{ width: '330px' }} /> */}
                          {((this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type !==
                            "misc_watch" &&
                            this.state.inventoryDetailByIdDetails.type !==
                            "misc_product") ||
                            this.state.inventoryDetailByIdDetails.type ===
                            null) && (
                              <>
                                <div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Brand Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails
                                                .brandname
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .brandname
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Number
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.reference &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.reference
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.reference
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.model &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.model
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.model
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casematerial &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casematerial
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casematerial
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Size
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casesize &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casesize
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.casesize
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Back
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caseback &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caseback
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caseback
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Shape
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.shape &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.shape
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.shape
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Dial Color
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.dialcolor &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.dialcolor
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.dialcolor
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Band Type
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandtype &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandtype
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandtype
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Band Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandmaterial &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandmaterial
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.bandmaterial
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Caliber
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caliber &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caliber
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.caliber
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Power Reserve
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails &&
                                            this.state
                                              .inventoryDetailByIdDetails
                                              .invattr &&
                                            this.state
                                              .inventoryDetailByIdDetails
                                              .invattr.powerreserve &&
                                            this.state
                                              .inventoryDetailByIdDetails
                                              .invattr.powerreserve
                                              ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.powerreserve
                                              : "---"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div> */}
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Water Resistent
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.waterresistant &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.waterresistant
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .invattr.waterresistant
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Purchase Date</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right">
                                                                            <b>{this.state.inventoryDetailByIdDetails.purchasedate ? moment(this.state.inventoryDetailByIdDetails.purchasedate).format('MM/DD/YYYY') : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Inventory Type</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>
                                                                        {this.state.inventoryDetailByIdDetails.inventorytype === "1" ? "regularinventory" : (this.state.inventoryDetailByIdDetails.inventorytype === "2" ? "memodetails" : (this.state.inventoryDetailByIdDetails.inventorytype === "3" ? "partnershipdetais" : "---" ))}</b></Typography>
                 
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Condition</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.condition ? this.state.inventoryDetailByIdDetails.condition : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Band Size1</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.bandsize ? this.state.inventoryDetailByIdDetails.bandsize : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>

                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Links</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.links ? this.state.inventoryDetailByIdDetails.links : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>
                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Purchase Price</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>$ {this.state.inventoryDetailByIdDetails.purchaseprice ? this.state.inventoryDetailByIdDetails.purchaseprice : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div>

                                                        <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Retail Price</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>$ {this.state.inventoryDetailByIdDetails.retailprice ? this.state.inventoryDetailByIdDetails.retailprice : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </div> */}
                                </div>
                              </>
                            )}

                          {this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type ===
                            "misc_watch" && (
                              <>
                                <div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.product_title
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .product_title
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Title
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.product_title
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .product_title
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Brand Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.brand_name
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .brand_name
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Number
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.model_number
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .model_number
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.case_material
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .case_material
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Case Size
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.case_size
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.case_size
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Dial Color
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.dial_color
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .dial_color
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Band Material
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.band_material
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .band_material
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                              </>
                            )}
                          {this.state.inventoryDetailByIdDetails.type &&
                            this.state.inventoryDetailByIdDetails.type ===
                            "misc_product" && (
                              <>
                                <div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.product_title
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .product_title
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Category
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right text-capitalize"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .category
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .category
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Product Title
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.product_title
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .product_title
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div> */}
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Description
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.description
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .description
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Brand Name
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.brand_name
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .brand_name
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <div className="space-bottom-5 space-top-5 border-bottom-1">
                                    <Grid container spacing={2}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="color-00000061"
                                          >
                                            Model Number
                                          </Typography>
                                        </div>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <div>
                                          <Typography
                                            variant="p"
                                            component="p"
                                            className="float-right"
                                          >
                                            <b>
                                              {this.state
                                                .inventoryDetailByIdDetails &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details.model_number
                                                ? this.state
                                                  .inventoryDetailByIdDetails
                                                  .technical_details
                                                  .model_number
                                                : "---"}
                                            </b>
                                          </Typography>
                                        </div>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </div>
                              </>
                            )}
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={4}
                          style={{ marginTop: "1px" }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Typography
                              variant="h5"
                              className="color-292C2F"
                              style={{ fontSize: "1rem" }}
                            >
                              <b>Inventory Details</b>
                            </Typography>
                          </div>
                          {/* <hr style={{ width: '330px' }} /> */}
                          {this.state.inventoryDetailByIdDetails.type !== 'misc_product' && (<>
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="color-00000061">Inventory Title</Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="float-right"><b>
                                      {/* {} */}
                                      {this.state.inventoryDetailByIdDetails.inventory_title ? this.state.inventoryDetailByIdDetails.inventory_title : (this.state
                                        .inventoryDetailByIdDetails &&
                                        this.state
                                          .inventoryDetailByIdDetails
                                          .technical_details &&
                                        this.state
                                          .inventoryDetailByIdDetails
                                          .technical_details.product_title
                                        ? this.state
                                          .inventoryDetailByIdDetails
                                          .technical_details
                                          .product_title
                                        : "---")}
                                    </b></Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          </>)}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Serial Number
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .serialno
                                        ? this.state.inventoryDetailByIdDetails
                                          .serialno
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Inventory ID
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .inventoryid
                                        ? this.state.inventoryDetailByIdDetails
                                          .inventoryid
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {this.state.inventoryDetailByIdDetails.type ===
                            "misc_product" && (
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Quantity
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .quantity
                                            ? this.state
                                              .inventoryDetailByIdDetails
                                              .quantity
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Inventory Type
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Tooltip title={this.state.inventoryDetailByIdDetails.inventorytype === "2" || this.state.inventoryDetailByIdDetails.inventorytype === "2" ?
                                    (this.state.inventoryDetailByIdDetails
                                      .inventorytype === "2" && (
                                        <b>
                                          {/* {this.state.inventoryDetailByIdDetails.serialno ? this.state.inventoryDetailByIdDetails.serialno : '---'} */}
                                          {this.state.inventoryDetailByIdDetails
                                            .memodetails
                                            ? this.state
                                              .inventoryDetailByIdDetails
                                              .memodetails
                                            : "---"}
                                        </b>
                                      )) : (
                                      this.state.inventoryDetailByIdDetails
                                        .inventorytype === "3" && (
                                        <b>
                                          {/* {this.state.inventoryDetailByIdDetails.serialno ? this.state.inventoryDetailByIdDetails.serialno : '---'} */}
                                          {this.state.inventoryDetailByIdDetails
                                            .partnershipdetais
                                            ? this.state
                                              .inventoryDetailByIdDetails
                                              .partnershipdetais
                                            : "---"}
                                        </b>
                                      ))}
                                  >
                                    <Typography
                                      variant="p"
                                      component="p"
                                      className="float-right"
                                    >
                                      <b>
                                        {/* {this.state.inventoryDetailByIdDetails.serialno ? this.state.inventoryDetailByIdDetails.serialno : '---'} */}
                                        {this.state.inventoryDetailByIdDetails
                                          .inventorytype === "1"
                                          ? "Regular Inventory"
                                          : this.state.inventoryDetailByIdDetails
                                            .inventorytype === "2"
                                            ? "Memo Inventory"
                                            : this.state.inventoryDetailByIdDetails
                                              .inventorytype === "3"
                                              ? "Partnership Inventory"
                                              : this.state.inventoryDetailByIdDetails
                                              .inventorytype === "5"
                                              ? "Consignment Inventory"
                                              : "---"}
                                      </b>
                                    </Typography>
                                  </Tooltip>
                                </div>
                              </Grid>
                            </Grid>
                          </div>


                          {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Inventory Type Details
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    {this.state.inventoryDetailByIdDetails.inventorytype === "2" && (
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                          .memodetails
                                          ? this.state
                                              .inventoryDetailByIdDetails
                                              .memodetails
                                          : "---"}
                                    </b>
                                    )}
                                     {this.state.inventoryDetailByIdDetails.inventorytype === "3" && (
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                          .partnershipdetais
                                          ? this.state
                                              .inventoryDetailByIdDetails
                                              .partnershipdetais
                                          : "---"}
                                    </b>
                                    )}

                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div> */}

                          {isActionAllowed(
                            this.state.viewData,
                            "purchase_from"
                          ) && (
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Purchase From
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .purchasefrom
                                            ? this.state
                                              .inventoryDetailByIdDetails
                                              .purchasefrom
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            )}

                          {isActionAllowed(
                            this.state.viewData,
                            "purchase_price"
                          ) && (
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Purchase Price
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          ${" "}
                                          {this.state.inventoryDetailByIdDetails
                                            .purchaseprice
                                            ? this.state
                                              .inventoryDetailByIdDetails
                                              .purchaseprice
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Date Added
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      {this.state.inventoryDetailByIdDetails
                                        .createdon
                                        // ? moment(
                                        //   this.state
                                        //     .inventoryDetailByIdDetails
                                        //     .createdon
                                        // ).format("MM/DD/YYYY")
                                        ? formatDate(this.state.inventoryDetailByIdDetails.createdon, "MM/DD/YYYY")
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Condition
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  {this.state.inventoryDetailByIdDetails
                                    .type !== "misc_product" && (
                                      <>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state.inventoryDetailByIdDetails
                                              .condition &&
                                              this.state.inventoryDetailByIdDetails
                                                .condition === 4
                                              ? "New"
                                              : this.state
                                                .inventoryDetailByIdDetails
                                                .condition &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .condition === 3
                                                ? "Retail Ready/Like New"
                                                : this.state
                                                  .inventoryDetailByIdDetails
                                                  .condition &&
                                                  this.state
                                                    .inventoryDetailByIdDetails
                                                    .condition === 2
                                                  ? "Mint/Very Good"
                                                  : "Used/Good"}
                                          </b>
                                        </Typography>
                                      </>
                                    )}
                                  {this.state.inventoryDetailByIdDetails
                                    .type === "misc_product" && (
                                      <>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state.inventoryDetailByIdDetails
                                              .condition &&
                                              this.state.inventoryDetailByIdDetails
                                                .condition === 1
                                              ? "New"
                                              : this.state
                                                .inventoryDetailByIdDetails
                                                .condition &&
                                                this.state
                                                  .inventoryDetailByIdDetails
                                                  .condition === 2
                                                ? "Used"
                                                : "New"}
                                          </b>
                                        </Typography>
                                      </>
                                    )}
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                              <>
                                <div className="space-bottom-5 space-top-5 border-bottom-1">
                                  <Grid container spacing={2}>
                                    <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Box
                                        </Typography>
                                      </div>
                                    </Grid>
                                    <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state.inventoryDetailByIdDetails
                                              .warrantybox &&
                                              this.state.inventoryDetailByIdDetails
                                                .warrantybox === "1"
                                              ? "Yes"
                                              : "No"}
                                          </b>
                                        </Typography>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </>
                            )}



                          {this.state.inventoryDetailByIdDetails.type !== "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography variant="p" component="p" className="color-00000061">
                                        Papers
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      {this.state.inventoryDetailByIdDetails.warrantypaper === "1" &&
                                        this.state.inventoryDetailByIdDetails.archive === 1 ? (
                                        <Typography variant="p" component="p" className="float-right">
                                          <b>Warranty and Archive</b>
                                        </Typography>
                                      ) : this.state.inventoryDetailByIdDetails.warrantypaper === "1" ? (
                                        <Typography variant="p" component="p" className="float-right" id="warranty">
                                          <b>Warranty</b>
                                        </Typography>
                                      ) : this.state.inventoryDetailByIdDetails.archive === 1 ? (
                                        <Typography variant="p" component="p" className="float-right" id="archive">
                                          <b>Archive</b>
                                        </Typography>
                                      ) : (
                                        <Typography variant="p" component="p" className="float-right">
                                          <b>{"---"}</b>
                                        </Typography>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}











                          {/* {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Warranty
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      {this.state.inventoryDetailByIdDetails
                                        .warrantypaper == 1 ? (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails
                                              .warrantydate
                                              ? moment(
                                                  this.state
                                                    .inventoryDetailByIdDetails
                                                    .warrantydate
                                                ).format("MM/DD/YYYY")
                                              : "No"}
                                          </b>
                                        </Typography>
                                      ) : (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>{"---"}</b>
                                        </Typography>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )} */}

                          {(this.state.inventoryDetailByIdDetails.type !== "misc_product" && this.state.inventoryDetailByIdDetails.warrantypaper === "1") && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1" id="warranty_date">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    {this.state.inventoryDetailByIdDetails.warrantypaper === "1" && (
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Warranty Date
                                        </Typography>
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      {this.state.inventoryDetailByIdDetails
                                        .warrantypaper === "1" ? (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails
                                              .warrantydate
                                              // ? moment(
                                              //   this.state
                                              //     .inventoryDetailByIdDetails
                                              //     .warrantydate
                                              // ).format("MM/DD/YYYY")
                                              ? formatDate(this.state.inventoryDetailByIdDetails.warrantydate, "MM/DD/YYYY")
                                              : "No"}
                                          </b>
                                        </Typography>
                                      ) : (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>{"---"}</b>
                                        </Typography>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}

                          {(this.state.inventoryDetailByIdDetails.type !== "misc_product" && this.state.inventoryDetailByIdDetails.archive === 1) && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1" id="archive_date">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    {this.state.inventoryDetailByIdDetails.archive === 1 && (
                                      <div>
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="color-00000061"
                                        >
                                          Archive Date
                                        </Typography>
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      {this.state.inventoryDetailByIdDetails
                                        .archive === 1 ? (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>
                                            {this.state
                                              .inventoryDetailByIdDetails
                                              .archive_date
                                              // ? moment(
                                              //   this.state
                                              //     .inventoryDetailByIdDetails
                                              //     .archive_date
                                              // ).format("MM/DD/YYYY")
                                              ? formatDate(this.state.inventoryDetailByIdDetails.archive_date, "MM/DD/YYYY")
                                              : "No"}
                                          </b>
                                        </Typography>
                                      ) : (
                                        <Typography
                                          variant="p"
                                          component="p"
                                          className="float-right"
                                        >
                                          <b>{"---"}</b>
                                        </Typography>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )}


                          {/* {this.state.inventoryDetailByIdDetails.type !==
                            "misc_product" && (
                            <>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Band Size
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .bandsize
                                            ? this.state
                                                .inventoryDetailByIdDetails
                                                .bandsize
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                              <div className="space-bottom-5 space-top-5 border-bottom-1">
                                <Grid container spacing={2}>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="color-00000061"
                                      >
                                        Links
                                      </Typography>
                                    </div>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6}>
                                    <div>
                                      <Typography
                                        variant="p"
                                        component="p"
                                        className="float-right"
                                      >
                                        <b>
                                          {this.state.inventoryDetailByIdDetails
                                            .links
                                            ? this.state
                                                .inventoryDetailByIdDetails
                                                .links
                                            : "---"}
                                        </b>
                                      </Typography>
                                    </div>
                                  </Grid>
                                </Grid>
                              </div>
                            </>
                          )} */}

                          {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                     <Typography variant="p" component="p" className="color-00000061">Warranty Paper</Typography>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                     <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.warrantypaper ? this.state.inventoryDetailByIdDetails.warrantypaper : '---'}</b></Typography>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                    <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={12}>
                                                                <div>
                     <Typography variant="p" component="p" className="color-00000061">Purchase Invoice</Typography>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                     <Slider {...settings} className="slide-invdetail">
                         {((this.state.inventoryDetailByIdDetails &&
                             this.state.inventoryDetailByIdDetails.purchaseinvoiceimages &&
                             this.state.inventoryDetailByIdDetails.purchaseinvoiceimages.images) || []).map(url => (
                                 <img src={url || defaulutImg} alt="rolex" className="img-width-23 img-responsive1" style={{ display: 'initial', width: 'auto', maxHeight: '300px', marginLeft: '-5px' }} />

                             ))}
                     </Slider>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div> */}
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} style={{ marginTop: '1px', }}>
                          <div style={{ textAlign: 'center' }}>
                            <Typography variant="h5" className="color-292C2F" style={{ fontSize: "1rem" }}><b>Inventory Details</b></Typography>
                          </div>
                          {/* <hr style={{ width: '330px' }} /> */}
                          {/* {this.state.inventoryDetailByIdDetails.type !== 'misc_product' && (<>
                                                    <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                     <Typography variant="p" component="p" className="color-00000061">Inventory Title</Typography>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                     <Typography variant="p" component="p" className="float-right"><b>
                                                                        {this.state.inventoryDetailByIdDetails.inventory_title ? this.state.inventoryDetailByIdDetails.inventory_title : '---'}
                                                                        </b></Typography>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                    </>)} */}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography variant="p" component="p" className="color-00000061">Inventory Status</Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.inventory_status ? renderInventoryStatusLabel(this.state.inventoryDetailByIdDetails.inventory_status, InventoryStatusLookup) : '---'}</b></Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {isActionAllowed(this.state.viewData, 'total_cost') && (
                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="color-00000061">Total Cost</Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.total_cost ? this.state.inventoryDetailByIdDetails.total_cost : '---'}</b></Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                          )}
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Target Wholesale Price
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      ${" "}
                                      {this.state.inventoryDetailByIdDetails
                                        .wholesaleprice
                                        ? this.state.inventoryDetailByIdDetails
                                          .wholesaleprice
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Target End Customer Price
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      ${" "}
                                      {this.state.inventoryDetailByIdDetails
                                        .retailprice
                                        ? this.state.inventoryDetailByIdDetails
                                          .retailprice
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="color-00000061"
                                  >
                                    Target End Customer Wire Price
                                  </Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography
                                    variant="p"
                                    component="p"
                                    className="float-right"
                                  >
                                    <b>
                                      ${" "}
                                      {this.state.inventoryDetailByIdDetails
                                        .retailwireprice
                                        ? this.state.inventoryDetailByIdDetails
                                          .retailwireprice
                                        : "---"}
                                    </b>
                                  </Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography variant="p" component="p" className="color-00000061">Public Dealer Note</Typography>
                                </div>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6}>
                                <div>
                                  <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.public_dealer_note ? this.state.inventoryDetailByIdDetails.public_dealer_note : '---'}</b></Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          <div className="space-bottom-5 space-top-5 border-bottom-1">
                            <Grid container spacing={2}>
                              <Grid item xs={5} sm={4} md={3}>
                                <div>
                                  <Typography variant="p" component="p" className="color-00000061">Private Dealer Note</Typography>
                                </div>
                              </Grid>
                              <Grid item xs={7} sm={8} md={9}>
                                <div>
                                  <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.note ? this.state.inventoryDetailByIdDetails.note : '---'}</b></Typography>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                          {this.state.inventoryDetailByIdDetails.type !== 'misc_product' && (<>

                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="color-00000061">Inventory Location</Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                  <div>
                                    <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.inventory_location ? this.state.inventoryDetailByIdDetails.inventory_location : '---'}</b></Typography>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>

                            <div className="space-bottom-5 space-top-5 border-bottom-1">
                              <Grid container spacing={2}>
                                <Grid item xs={5} sm={4} md={3}>
                                  <div>
                                    <Typography variant="p" component="p" className="color-00000061">Modified</Typography>
                                  </div>
                                </Grid>
                                <Grid item xs={7} sm={8} md={9}>
                                  <div>
                                    <Tooltip arrow title={this.state.inventoryDetailByIdDetails.ismodified === true && (
                                      <b>{this.state.inventoryDetailByIdDetails.modification_deatils ? this.state.inventoryDetailByIdDetails.modification_deatils : '---'}</b>
                                    )} >
                                      <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.ismodified === true ? "Yes" : 'No'}</b></Typography>
                                    </Tooltip>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                            {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                 <Grid container spacing={2}>
                                     <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography variant="p" component="p" className="color-00000061">Modification Details</Typography>
                                        </div>
                                     </Grid>
                                     <Grid item xs={6} sm={6} md={6}>
                                      <div>
                                        <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.modification_deatils ? this.state.inventoryDetailByIdDetails.modification_deatils : '---'}</b></Typography>
                                        </div>
                                     </Grid>
                                 </Grid>
                              </div> */}
                          </>)}
                          {/* {isActionAllowed(this.state.viewData,'purchase_expense') && (
                                                    <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Purchase Expense</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>$ {this.state.inventoryDetailByIdDetails.purchase_expense ? this.state.inventoryDetailByIdDetails.purchase_expense : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                    </div>
                                                    )} */}
                          {/* <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="color-00000061">Purchase Expense Note</Typography>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={6} sm={6} md={6}>
                                                                    <div>
                                                                        <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.purchase_expense_note ? this.state.inventoryDetailByIdDetails.purchase_expense_note : '---'}</b></Typography>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                    </div>
                                                    <div className="space-bottom-5 space-top-5 border-bottom-1">
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                                                                    <Typography variant="p" component="p" className="color-00000061">Tag Price</Typography>
                                                                </div>
                                                            </Grid>
                                                            <Grid item xs={6} sm={6} md={6}>
                                                                <div>
                                                                    <Typography variant="p" component="p" className="float-right"><b>{this.state.inventoryDetailByIdDetails.tag_price ? this.state.inventoryDetailByIdDetails.tag_price : '---'}</b></Typography>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                    </div> */}



                        </Grid>
                      </Grid>
                    </Card>
                  </Container>
                )}
              </div>
            </div>

          )
          }
        </div>
      )
    }
  }
  render() {

    localStorage.setItem("menuTitle", "");
    return <NewContentWrapper contentView={this.newContentView()} />;
  }
}
function mapStateToProps({ inventoryDetailByIdInfo }) {
  return {
    // inventoryDetailByIdInfo: inventoryDetailByIdInfo.inventoryDetailByIdInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      inventoryDetailById,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DealerInventoryDetailComponent);
